import { useEffect, useState } from "react";

import { Series, useGetAllSeriesQuery } from "../redux/slices/series-api";

export type GetSeries = {
  series: Series[];
  loading: boolean;
};

export enum SeriesSortValues {
  name = "name",
  noOfPlays = "noOfPlays",
}

export type useGetSeriesProps = {
  searchTerm: string;
  sort: { sortValue: SeriesSortValues; sortDirection: string };
};

export const useGetSeries = ({ searchTerm, sort }: useGetSeriesProps): GetSeries => {
  const [series, setSeries] = useState<Series[]>([]);
  const { data: seriesData, isLoading: loading } = useGetAllSeriesQuery();

  useEffect(() => {
    if (seriesData) {
      setSeries(seriesData);
    }
  }, [seriesData]);

  useEffect(() => {
    if (seriesData) {
      const filteredSeriesData = searchTerm
        ? seriesData.filter((series) => series.name.toLowerCase().includes(searchTerm.toLowerCase()))
        : seriesData;

      const sortedSeriesData = sort.sortValue
        ? [...filteredSeriesData].sort((a, b) => {
            if (sort.sortDirection === "asc") {
              return a[sort.sortValue] > b[sort.sortValue] ? 1 : -1;
            } else {
              return a[sort.sortValue] < b[sort.sortValue] ? 1 : -1;
            }
          })
        : filteredSeriesData;

      setSeries(sortedSeriesData);
    }
  }, [seriesData, searchTerm, sort]);

  return { series, loading };
};
